import { SEO_COLORS } from 'cards/constants/Cards';
import _uniqBy from 'lodash/uniqBy';
import { getCapitalized } from 'paper/utils/helpers';
import { Motif, MOTIF_NAMES, PARAM_KEY_TO__FILTER } from '../types';
import featureFlags from '../../../../util/featureFlags';
import { FilterKey, FilterValue } from './CardListingFilter/FilterTypes';

export function getQueryFromFilter(
  key: keyof typeof PARAM_KEY_TO__FILTER,
  value: FilterValue,
  query?: Record<string, string>,
  urlKey?: string
): string {
  const paramKey = PARAM_KEY_TO__FILTER[key] || '';
  const queryKey = urlKey || key;
  let newQuery;

  if (query && query[queryKey]) {
    newQuery = value
      ? `${query[queryKey]},${paramKey}`
      : query[queryKey]
          .split(',')
          .filter(e => e !== paramKey)
          .join(',');
  } else {
    newQuery = paramKey;
  }
  return newQuery;
}

export function getFilter(
  filters: string[],
  onUpdateSearchFilters: (filterName: FilterKey, isFiltering: boolean) => void
): void {
  filters.forEach(filter => {
    const property = Object.keys(PARAM_KEY_TO__FILTER).find(
      each => filter === PARAM_KEY_TO__FILTER[each]
    );
    if (property) {
      onUpdateSearchFilters(property as FilterKey, true);
    }
  });
}

export const removeElementWithUuidDuplicates = <T extends { uuid: string }>(array: T[]): T[] =>
  _uniqBy(array, 'uuid');

export const getMotifsFromUrl = (urlFilter: string): string[] => {
  if (!urlFilter) return [];
  const activeStyles = urlFilter.split('--');
  const activeMotifFilterStyles = activeStyles
    .filter(e => !SEO_COLORS.includes(e.toUpperCase()))
    .map(e => getCapitalized(e));
  return activeMotifFilterStyles;
};

export const getSeoColorsFromUrl = (urlFilter: string): string[] => {
  if (!urlFilter || !featureFlags.get('seoColorSeasonFilters')) return [];
  const activeStyles = urlFilter.split('--');
  const activeSeoColorFilterStyles = activeStyles
    .filter(e => SEO_COLORS.includes(e.toUpperCase()))
    .map(e => e.toUpperCase());
  return activeSeoColorFilterStyles;
};

export const getFullSeoFiltersFromUrl = (urlFilter: string): string[] => {
  if (!urlFilter) return [];
  const activeStyles = urlFilter.split('--');
  const activeFilterStyles = featureFlags.get('seoColorSeasonFilters')
    ? activeStyles.map(e => e.toUpperCase())
    : activeStyles.filter(e => !SEO_COLORS.includes(e.toUpperCase())).map(e => getCapitalized(e));
  return activeFilterStyles;
};

export const getTitleCase = (text: string): string => {
  return text
    .split('_')
    .map((word: string) => word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const getHeroNamedStyle = (allMotifs: Motif[] = [], styleKey = ''): string => {
  const motifInfo: Motif =
    allMotifs.find(each => each.key === getTitleCase(styleKey)) || ({} as Motif);
  // The first 2 return values apply to motifs
  // The last return value applies to seo colours
  return MOTIF_NAMES[styleKey.toLowerCase()] || motifInfo.name || getTitleCase(styleKey);
};

export const existenceCheck = (value: FilterValue): boolean => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return Boolean(value);
};

export const filterTransformation = (
  key: keyof typeof PARAM_KEY_TO__FILTER,
  value: FilterValue,
  query?: Record<string, string>,
  urlKey?: string
): string | null => {
  if (Array.isArray(value)) {
    return value.join(',').toLowerCase();
  }
  if (key === 'is_letterpress') {
    return value ? key : null;
  }

  return getQueryFromFilter(key, value, query, urlKey);
};
